<div class="w-[full] bg-[#173a57] p-[1rem]">
  <div class="ml-[15px]">
    <button (click)="navigateBack()" type="button" class="back-btn">
      Back
    </button>
  </div>
  <!-- <div
    class="profile-header bg-[#173a57] text-white p-2 flex justify-between items-center"
  >
    <div class="organization-info m-0 font-bold text-[#F1F3F5] mt-6">
      <p>{{ user.organization.name }}</p>
      <p>{{ user.organization.type }}</p>
    </div>
  </div> -->
  <!-- <div
    class="text-[24px] text-[#203D54] font-bold !font-inter bg-white h-[60px] flex items-center pl-14 !mt-[55px]"
  >
    <label for="profile">Profile</label>
  </div> -->
  <div class="flex justify-between items-center">
    <div
      class="profile-container flex items-center !rounded-full bg-[#173a57] pl-0 pb-5 pt-5 pr-5 text-white"
    >
      <div class="avatar w-[100px] h-[100px] rounded-full overflow-hidden">
        <img
          src="assets/images/org_logo.jpeg"
          alt="Avatar"
          class="w-full h-full object-cover rounded-full"
        />
      </div>

      <div class="user-info ml-[13px] mt-[13px]">
        <h2 class="!text-[24px] !font-bold">BuildCroft</h2>
      </div>
    </div>
    <div>
      <div class="flex !justify-end mb-[-20px] mr-[1.8rem] text-[#F1F3F5]">
        <p>Complete Your Profile</p>
      </div>
      <div class="relative">
        <div
          class="profile-progress flex items-end gap-2.5 !h-[50px] justify-end"
        >
          <mat-progress-bar
            class="!w-[150px] !h-[50px]"
            mode="determinate"
            [value]="profileCompletion"
          >
          </mat-progress-bar>

          <span class="text-white mb-[15px]">{{ profileCompletion }}%</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Expansion Panels -->
  <div class="flex items-center justify-center w-[100%]">
    <mat-accordion class="mt-[50px] bg-[#173a57] w-[100%]">
      <mat-expansion-panel
        class="!bg-[#F1F3F5] !mb-[20px] !rounded-[10px] overflow-hidden w-[100%] mt-[50px] mt-50px flex-shrink-0 shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="font-medium !text-[#203D54] text-[20px]"
            >Client Information</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <!-- <label for="clientinformation"
        class="text-[#203D54] text-[24px]  font-bold">Client Information</label> -->
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="clientname"
              class="text-[#203D54] text-[18px] font-bold font- Roboto"
              >Client Name</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="clientname"
                formControlName="clientname"
                type="text"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Your Client Name"
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="contactperson"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Contact Person</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="contactperson"
                formControlName="contactperson"
                type="text"
                class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Your Contact Person Name"
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label for="jobtitle" class="text-[#203D54] text-[18px] font-bold"
              >Job Title</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="jobtitle"
                formControlName="jobtitle"
                type="text"
                class="w-full bg-[#F1F3F5] ml-[-500px] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Contact Person’s Position "
              />
            </div>
          </div>
          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="!bg-[#F1F3F5] !mb-[20px] !rounded-xl w-[100%] mt-50px flex-shrink-0 ] shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title
            class="font-medium font-Roboto !text-[#203D54] text-[20px]"
            >Contact Details</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <!-- <label for="clientdetails"
        class="text-[#203D54] text-[24px]  font-bold">Client Details</label> -->
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="emailaddress"
              class="text-[#203D54] text-[18px] font-bold font- Roboto"
              >Email Address</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="emailaddress"
                formControlName="emailaddress"
                type="email"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Your Email Address "
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="contactnoprimary"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Contact No (Primary)</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="contactnoprimary"
                formControlName="contactnoprimary"
                type="tel"
                class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Your Contact No (Primary)"
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for=" contactnosecondary"
              class="text-[#203D54] text-[18px] font-bold"
            >
              Contact No (Secondary)</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="contactnosecondary"
                formControlName="contactnosecondary"
                type=""
                class="w-full bg-[#F1F3F5] ml-[-500px] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Your Contact No ( Secondary) "
              />
            </div>
          </div>
          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="!bg-[#F1F3F5] w-[100%] !mb-[20px] !rounded-xl mt-50px flex-shrink-0 shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="font-medium !text-[#203D54] text-[20px]"
            >Address Information</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <!-- <label for="clientdetails"
        class="text-[#203D54] text-[24px]  font-bold">Address Information</label> -->
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="officeaddress"
              class="text-[#203D54] text-[18px] font-bold font- Roboto"
              >Office Address</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="officeaddress"
                formControlName="officeaddress"
                type="text"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Your Office Address  "
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="billingaddress"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Billing Address</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="billingaddress"
                formControlName="billingaddress"
                type="text"
                class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Your Billing Address "
              />
            </div>
          </div>
          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="!bg-[#F1F3F5] w-[100%] !mb-[20px] !rounded-xl mt-50px flex-shrink-0 shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="font-medium !text-[#203D54] text-[20px]"
            >Company Information</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <!-- <label for="companyinformation"
        class="text-[#203D54] text-[24px]  font-bold">Company Information</label> -->
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="companyinformation"
              class="text-[#203D54] text-[18px] font-bold font- Roboto"
              >Industry</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="companyinformation"
                formControlName="companyinformation"
                type="text"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder=" Enter Industry Sector  "
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="companysize"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Company Size</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="companysize"
                formControlName="companysize"
                type="number"
                class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Your Number of Employees"
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for=" contactnosecondary"
              class="text-[#203D54] text-[18px] font-bold"
            >
              Contact No (Secondary)</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="contactnosecondary"
                formControlName="contactnosecondary"
                type=""
                class="w-full bg-[#F1F3F5] ml-[-500px] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Your Contact No ( Secondary) "
              />
            </div>
          </div>
          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="!bg-[#F1F3F5] w-[100%] !mb-[20px] !rounded-xl mt-50px flex-shrink-0 shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="font-medium !text-[#203D54] text-[20px]"
            >Client Status and Classification</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="clienttype"
              class="text-[#203D54] text-[18px] font-bold font- Roboto"
              >Client Type</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="clienttype"
                formControlName="clienttype"
                type="text"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Client Category  "
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="clientstatus"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Client Status</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="clientstatus"
                formControlName="clientstatus"
                type="text"
                class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Client Status"
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="   Lead Source"
              class="text-[#203D54] text-[18px] font-bold"
            >
              Lead Source</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id=" Lead Source"
                formControlName=" Lead Source"
                type="text"
                class="w-full bg-[#F1F3F5] ml-[-500px] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Lead Source"
              />
            </div>
          </div>
          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="!bg-[#F1F3F5] w-[100%] !mb-[20px] !rounded-xl mt-50px flex-shrink-0 shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="font-medium !text-[#203D54] text-[20px]"
            >Relationship and Communications</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="accountmanager"
              class="text-[#203D54] text-[18px] font-bold font- Roboto"
              >Account Manager</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="accountmanager"
                formControlName="accountmanager"
                type="text"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Your Manager Name  "
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="communicationpreferences"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Communication Preferences</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="communicationpreferences"
                formControlName="communicationpreferences"
                type="text"
                class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder=" Email/Phone"
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="contacttimes"
              class="text-[#203D54] text-[18px] font-bold"
            >
              Preferred Contact Times</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id=" contacttimes"
                formControlName=" contacttimes"
                type="time"
                class="w-full bg-[#F1F3F5] ml-[-500px] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Preferred Contact Time"
              />
            </div>
          </div>
          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="!bg-[#F1F3F5] w-[100%] !mb-[20px] !rounded-xl mt-50px flex-shrink-0 shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="font-medium text-[20px] !text-[#203D54]"
            >Client Needs and Interest</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="productofinterest"
              class="!text-[#203D54] text-[18px] font-bold font- Roboto"
              >Product of Interest</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="productofinterest"
                formControlName="productofinterest"
                type="text"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Product of Interests  "
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="keyrequirements"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Key Requirements</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="keyrequirements"
                formControlName="keyrequirements"
                type="text"
                class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Key requirements"
              />
            </div>
          </div>

          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="!bg-[#F1F3F5] w-[100%] !mb-[20px] !rounded-xl mt-50px flex-shrink-0 shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="font-medium text-[20px] !text-[#203D54]"
            >Financial Details (Optional)</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="budgetrange"
              class="text-[#203D54] text-[18px] font-bold font- Roboto"
              >Budget Range</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="budgetrange"
                formControlName="budgetrange"
                type="text"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Budget Range "
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="paymentterms"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Payment Terms</label
            >
            <div class="relative w-[377px]">
              <input
                required="required"
                id="paymentterms"
                formControlName="paymentterms"
                type="text"
                class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Payment Terms"
              />
            </div>
          </div>

          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="!bg-[#F1F3F5] w-[100%] h-[ 84.207px] !mb-[20px] !rounded-xl mt-50px flex-shrink-0 shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="font-medium !text-[#203D54] text-[20px]"
            >History and Notes</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="interactionhistory"
              class="text-[#203D54] text-[18px] font-bold font- Roboto"
              >Interaction History</label
            >
            <div class="relative w-[377px]">
              <input
                id="interactionhistory"
                formControlName="interactionhistory"
                type="text"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Summary of Past communications "
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="keyrequirements"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Key Decision Makers</label
            >
            <div class="relative w-[377px]">
              <select
                id="keyrequirements"
                formControlName="keyrequirements"
                class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
              >
                <option value="">List Significant Contacts</option>
                <option value="CEO">CEO</option>
                <option value="CFO">CFO</option>
                <option value="CTO">CTO</option>
                <option value="COO">COO</option>
                <option value="VP">Vice President</option>
                <option value="Director">Director</option>
                <option value="Manager">Manager</option>
              </select>
              <!-- <input
              
              id="keyrequirements"
              formControlName="keyrequirements"
              type=""
              class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
              placeholder="Enter Key requirements"
            /> -->
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="keyrequirements"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Special Instructions</label
            >
            <div class="relative w-[377px]">
              <input
                id=" uniquerequirements"
                formControlName="uniquerequirements"
                type="text"
                class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter unique requirements from client"
              />
            </div>
          </div>

          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="!bg-[#F1F3F5] w-[100%] !mb-[20px] !rounded-xl mt-50px flex-shrink-0 shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="font-medium text-[20px] !text-[#203D54]"
            >Compliance and consents</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="privacycompliance"
              class="text-[#203D54] text-[18px] font-bold font- Roboto"
              >GDPR/Privacy Compliance</label
            >
            <div class="relative w-[377px]">
              <input
                id="privacycompliance"
                formControlName="privacycompliance"
                type="text"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder=" Confirm Client Consent For Data  "
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="MarketingOptIn"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Marketing Opt-In</label
            >
            <div class="relative w-[377px]">
              <input
                id="MarketingOptIn"
                formControlName="MarketingOptIn"
                type="text"
                class="w-full bg-[#F1F3F5] text-[#203D54] text-[14px] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Confirm Client receive marketing communications."
              />
            </div>
          </div>

          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="!bg-[#F1F3F5] w-[100%] !mb-[20px] !rounded-xl mt-50px flex-shrink-0 shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="font-medium text-[20px] !text-[#203D54]"
            >Documents and Attachments</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="contractsagreements"
              class="text-[#203D54] text-[18px] font-bold font- Roboto"
              >Contracts/Agreements</label
            >
            <div class="relative w-[377px]">
              <input
                id="contractsagreements"
                formControlName="contractsagreements"
                type="file"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder=" Attach Relevant Documents  "
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="clientbriefs"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Client Briefs</label
            >
            <div class="relative w-[377px]">
              <div class="relative w-[377px]">
                <textarea
                  id="clientbriefs"
                  formControlName="clientbriefs"
                  class="w-full bg-[#F1F3F5] text-[#203D54] text-[14px] h-[105px] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] rounded-[10px] py-[10px] flex-shrink-0"
                  placeholder="Upload Project Briefs Client Requirements."
                  rows="4"
                ></textarea>
              </div>
            </div>
          </div>

          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="!bg-[#F1F3F5] !mb-[20px] !rounded-xl w-[100%] mt-50px flex-shrink-0 ] shadow-[0px_4.058px_4.058px_rgba(0,0,0,0.25)]"
      >
        <mat-expansion-panel-header>
          <mat-panel-title
            class="font-medium font-Roboto !text-[#203D54] text-[20px]"
          >
            Next Steps and Actions</mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="mt-[28px]">
          <!-- <label for="clientdetails"
        class="text-[#203D54] text-[24px]  font-bold">Client Details</label> -->
          <div class="flex items-center justify-between mt-[40px]">
            <label
              for="followupdate"
              class="text-[#203D54] text-[18px] font-bold font- Roboto"
              >Follow-Up Date</label
            >
            <div class="relative w-[377px]">
              <input
                id="followupdate"
                formControlName="followupdate"
                type="text"
                class="w-full bg-[#F1F3F5] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] ml-[-500px] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter Summary of Past communications "
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label
              for="tasktodo"
              class="text-[#203D54] text-[18px] font-bold !font-Roboto"
              style="font-family: Roboto"
              >Tasks/To-Do</label
            >
            <div class="relative w-[377px]">
              <input
                id="tasktodo"
                formControlName="tasktodo"
                type="text"
                class="w-full bg-[#F1F3F5] text-[#203D54] mt-[19px] border-[1px] ml-[-500px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="List  Significant Contacts"
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <label for=" remarks" class="text-[#203D54] text-[18px] font-bold">
              Remarks</label
            >
            <div class="relative w-[377px]">
              <input
                id="remarks"
                formControlName="remarks"
                type=""
                class="w-full bg-[#F1F3F5] ml-[-500px] mt-[19px] text-[#203D54] border-[1px] border-[#203D54] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Enter unique requirements from client "
              />
            </div>
          </div>
          <div
            class="w-[114px] h-[48px] float-end bg-[#2368A2] rounded-2xl flex items-center justify-center mr-[50px]"
          >
            <button
              class="text-[#F1F3F5] font-semibold justify-center !text-center"
            >
              Save
            </button>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
